module.exports = TextEncoder;